<template>
  <!-- 修改广告对话框 -->
  <el-dialog
    title="修改广告"
    :visible.sync="editDialogVisible"
    width="80%"
  >
    <el-form ref="editFormRef" :rules="rules" :model="editForm" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="广告类型" prop="enumType">
            <el-select v-model="editForm.enumType" clearable placeholder="请选择广告类型" style="width: 100%">
              <el-option
                v-for="item in advertise"
                :key="item.id"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-col :span="12">
            <el-form-item label="小程序路径" prop="page">
              <el-input v-model="editForm.page" placeholder="请输入小程序路径" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否启用" prop="enumEnable">
              <el-select v-model="editForm.enumEnable" clearable placeholder="请选择是否启用" style="width: 100%">
                <el-option key="NORMAL" label="是" value="NORMAL"></el-option>
                <el-option key="DISABLE" label="否" value="DISABLE"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="图片广告" v-if="editForm.enumType==='PICTURE'" prop="content">
              <thumbnail v-model="editForm.content" :md5s="editForm.content"></thumbnail>
            </el-form-item>
            <el-form-item label="视频广告" v-if="editForm.enumType==='VIDEO'" prop="content">
              <QqVideo v-model="editForm.content" :md5s="editForm.content"></QqVideo>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="modifyAdvertise">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateAdvertise } from '@/api/advertise/advertise'
import { getPostOrDeleteData } from '@/utils/code'
import { ADVERTISE } from '@/js/enum'
import QqVideo from '@/components/common/qqVideo/qqVideo'
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import { advertisRules } from '@/js/rules'

export default {
  name: 'editAdvertise',
  components: { QqVideo, Thumbnail },
  data() {
    return {
      advertise: ADVERTISE,
      editForm: {}, //修改
      editDialogVisible: false,
      rules: advertisRules
    }
  },
  methods: {
    cancel() {
      this.editDialogVisible = false
      this.editForm = {}
    },
    editDialog(row) {
      this.editForm = JSON.parse(JSON.stringify(row))
      this.editDialogVisible = true
    },
    modifyAdvertise() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        updateAdvertise(this.editForm.id, this.editForm).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.$emit('refresh-list')
            this.editDialogVisible = false
          }
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
